import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerIdFilter',
  pure: false
})
export class CustomerIdFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, filterValue: string): any {
    if (!customerList || !filterValue) {
      return customerList;
    }
    const normalizedFilter = filterValue.toString().trim().toLowerCase();
    return customerList.filter(customer =>
      String(customer.IDCustomer ?? '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
